import moment from "moment";
import "moment/locale/zh-cn";

/**
 *
 * @returns 获取当前时间
 */
export function getNowDate() {
  return moment().format("YYYY-MM-DD HH:mm:ss");
}

// 防抖函数
export function debounce(func, wait) {
  let timeout;
  return function () {
    // 清空定时器
    if (timeout) clearTimeout(timeout);
    timeout = setTimeout(func, wait);
  };
}
/**
 * 将moment日期格式化为YYYYMMDD字符串
 * @param {*} date moment日期
 */
export function formatMomentDate(date) {
  return moment(date, "YYYYMMDD")
    .format("L")
    .replace("/", "")
    .replace("/", "");
}

export function getYesterday() {
  return moment()
    .add(-1, "days")
    .format("L")
    .replace("/", "")
    .replace("/", "");
}

export function deepClone(source) {
  if (!source && typeof source !== "object") {
    throw new Error("error arguments", "deepClone");
  }
  if (source !== null) {
    const targetObj = source.constructor === Array ? [] : {};
    Object.keys(source).forEach((keys) => {
      if (source[keys] && typeof source[keys] === "object") {
        targetObj[keys] = deepClone(source[keys]);
      } else {
        targetObj[keys] = source[keys];
      }
    });
    return targetObj;
  }
  return null;
}

//金额千分位格式化
export function formatWithMod(n) {
  if (!n) return n;
  let str = n.split(".");
  let re = /\d{1,3}(?=(\d{3})+$)/g;
  let n1 = str[0].replace(re, "$&,");
  return str.length > 1 && str[1] ? `${n1}.${str[1]}` : `${n1}.00`;
}

export function sizeFormat(size) {
  var a = null
  if (size) {
    if (size < 1024) {
      a = size + 'B'
    } else if (size < 1024 * 1024) {
      a = (size / 1024).toFixed(2) + 'K'
    } else if (size < 1024 * 1024 * 1024) {
      a = (size / 1024 / 1024).toFixed(2) + 'M'
    } else {
      a = (size / 1024 / 1024 / 1024).toFixed(2) + 'G'
    }
  }
  return a
}


/**
   * 判断editor富文本域是否为空
   * str返回的值为"" 代表输入框里面有值 成功
   * str返回！="" 代表里面有空格 回车 失败
   * */
export function checkVal(str) {
  let num = 0,
    reg = /<p>(&nbsp;|&nbsp;\s+)+<\/p>|<p>(<br>)+<\/p>/g;
  while (num < str.length && str != "") {
    num++;
    let k = str.match(reg);
    if (k) {
      str = str.replace(k[0], "");
    }
  }
  return str == "";
}

/** 图片放大功能所需方法 */
export function cutContent(picList, content) {
  let temp = [];
  let startIndex = 0;
  let endIndex = 0;
  temp = [];
  //切割
  if (picList.length > 0) {
    for (let j = 0; j < picList.length; j++) {
      endIndex = picList[j].index;
      temp.push(content.slice(startIndex, endIndex));
      startIndex = endIndex;
      endIndex = startIndex + picList[j].picBig.length;
      temp.push(content.slice(startIndex, endIndex));
      startIndex = endIndex;
      if (j == picList.length - 1) {
        temp.push(content.slice(startIndex));
      }
    }
    let num = 0;
    for (let j in temp) {
      if (temp[j].indexOf("<img") > -1) {
        temp[j] = picList[num];
        num = num + 1;
      }
    }
    return temp;
  } else {
    return [content];
  }
};
/** 图片放大功能所需方法 */

export function getPicList(detail) {
  let imgReg = /<img.*?(?:>|\/>)/gi; //匹配图片中的img标签
  let detailPicList = [];
  if (detail) {
    detail.replace(imgReg, function (match, capture) {
      detailPicList.push({
        index: capture,
        picBig: match,
        srcBig: match.match(/src=[\'\"]?([^\'\"]*)[\'\"]?/i)[1],
      });
    });
  }
  return detailPicList;
};

/* 是否手机号码或者固话*/
export function validatePhoneTwo(rule, value, callback) {
  const reg = /^((0\d{2,3}-\d{7,8})|(1[345789]\d{9}))$/;;
  if (value == '' || value == undefined || value == null) {
    callback();
  } else {
    if ((!reg.test(value)) && value != '') {
      callback(new Error('请输入正确的电话号码或者固话号码'));
    } else {
      callback();
    }
  }
}

// 获取本周、上周、近一月、本月、本季度、本年日期 YYYYMMDD
export function getMyDate() {
  const time = {}
  time.bz =
    moment().week(moment().week()).startOf("week").format("YYYYMMDD") +
    "-" +
    moment().week(moment().week()).endOf("week").format("YYYYMMDD");
  time.sz =
    moment().subtract(1, 'week').startOf('week')
      .format("YYYYMMDD") +
    "-" +
    moment().subtract(1, 'week').endOf('week')
      .format("YYYYMMDD");
  time.jyy =
    moment(new Date()).subtract(1, "months").format("YYYYMMDD") +
    "-" +
    moment(new Date()).format("YYYYMMDD");
  time.by =
    moment().startOf("month").format("YYYYMMDD") +
    "-" +
    moment().endOf("month").format("YYYYMMDD");

  time.bj =
    moment().startOf("quarter").format("YYYYMMDD") +
    "-" +
    moment().endOf("quarter").format("YYYYMMDD");
  time.bn =
    moment().startOf("year").format("YYYYMMDD") +
    "-" +
    moment().endOf("year").format("YYYYMMDD");
  return time;
}

// 导出文件添加日期
export function addExportFileDate(fileName) {
  const exportDate = "_" + moment().format("YYYYMMDD");
  const pointIndex = fileName.indexOf(".");
  fileName =
    fileName.slice(0, pointIndex) +
    exportDate +
    fileName.slice(pointIndex);
  return fileName;
}

/**
 * 取得当前年份
 */
export function getCurrentYear() {
  return parseInt(moment().format("YYYY"), 0);
}
export function getCurrentQuarter() {
  return moment().quarter() + '';
}


//防抖函数
// export function debounce(fn, delay) {
//   let timeout = null;
//   return function () {
//     let context = this;
//     let args = arguments;
//     if (timeout) clearTimeout(timeout);
//     let callNow = !timeout;
//     timeout = setTimeout(() => {
//       timeout = null;
//     }, delay);
//     if (callNow) fn.apply(context, args);
//   };
// }